"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var dayjs_1 = __importDefault(require("dayjs"));

var getStartDay = function getStartDay(day) {
  return day.set('hour', 0).set('minute', 0).set('second', 0).set('millisecond', 0);
};

exports.getStartDay = getStartDay;

var getEndDay = function getEndDay(day) {
  return day.set('hour', 23).set('minute', 59).set('second', 59).set('millisecond', 999);
};

exports.getEndDay = getEndDay;

var initRange = function initRange(minusDays, stepMode) {
  var initDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : dayjs_1.default();

  // tslint:disable-next-line: no-small-switch
  switch (stepMode) {
    case 'week':
      {
        var end = getEndDay(initDay.subtract(initDay.day(), 'day'));
        var start = getStartDay(end.subtract(minusDays * 7 - 1, 'day'));
        return [start, end];
      }

    default:
      {
        var _end = getEndDay(initDay);

        var _start = getStartDay(_end.subtract(minusDays, 'day'));

        return [_start, _end];
      }
  }
};

exports.initRange = initRange;

var initNativeRange = function initNativeRange(range) {
  return range.map(function (x) {
    return x.toDate();
  });
};

exports.initNativeRange = initNativeRange;

var rangeToString = function rangeToString(range) {
  var start = range[0];
  var end = range[1];
  var strStart = start.format('YYYY-MM-DD');
  var endStart = end.format('YYYY-MM-DD');
  return "".concat(strStart, " \u2014 ").concat(endStart);
};

exports.rangeToString = rangeToString;